import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import InvestorNavBarMain from "./InvestorNavBar";
import InvestorSideNavBar from "./SideNavBarInvestor";
import axios from ".././axios-interceptor";
import moment from "moment";
import { base_url, NOTIFICATION_TYPE_INTEREST_RECEIVED_FROM_INVESTOR, LOAN_CURRENCY_TYPE_USD, NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY, NOTIFICATION_ENTITY_INVESTOR, NOTIFICATION_TYPE_RENEW_DOCUMENT, NOTIFICATION_ENTITY_ALLINVESTORS, NOTIFICATION_TYPE_PAYMENT_PROCESSED, NOTIFICATION_TYPE_KYC_APPROVED, NOTIFICATION_TYPE_KYC_REJECTED, NOTIFICATION_TYPE_LOAN_DELISTED, NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE } from "../utilities";
import Skeleton from "react-loading-skeleton";
import Cookies from 'js-cookie';

const InvestorNotifications = () => {
  const [activeTab, setActiveTab] = useState('home');
  const [loading, setLoading] = useState(true)

  function handleTabClick(tab) {
    setActiveTab(tab);
  }
  const navigate = useNavigate();
  useEffect(()=>{
    if (Cookies.get("User_Accesstoken_Investor") == null) {
      navigate('/');
    }
  },[])
  const [notificationData, setNotificationData] = useState([])
  useEffect(() => {
    axios
    .post(base_url + "investor-master/get_investor_master_user", {
      user_id: Cookies.get("investor_user_id"),
    })
    .then((res) => {
    axios
      .post(base_url + 'notifications/get_investor_notifications',
        {
          "user_id": res?.data?.data[0]?.investor_id,
          "notify_to":NOTIFICATION_ENTITY_INVESTOR
        })
      .then((res) => {
        setNotificationData(res.data.data)
        setLoading(false)
      })})

  }, [])



  let Count = [];
  let notificationList = []

  notificationData?.forEach(notifi => {
    if (notifi.notify_to === NOTIFICATION_ENTITY_ALLINVESTORS) {
      if (notifi.is_read_investor.length == 0) {
        Count.push(notifi)
      }
      else {
        if (notifi.is_read_investor.indexOf(Cookies.get("investor_id")) === -1) {
          Count.push(notifi)
        }
      }
    }
    if(notifi.notify_to === NOTIFICATION_ENTITY_INVESTOR){
      if (notifi.is_read !== 1) {
        Count.push(notifi)
      }
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY) {
      notificationList.push(
        {
          heading: 'New investment opportunity!',
          msgBody: `Invest ${notifi.loan_currency === LOAN_CURRENCY_TYPE_USD ? "$ " + Number(notifi.loan_amount).toLocaleString() : 'BHD ' + Number(notifi.loan_amount).toLocaleString()} with tenure of ${notifi.loan_tenure === 1 ? notifi.loan_tenure + " Month" : notifi.loan_tenure + " Months "} in ${notifi.business_name} and get profit upto ${Number(notifi.profit).toLocaleString() + "%"}`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          notify_to : notifi.notify_to,
          //is_read: notifi.is_read,
          is_read_investor : notifi.is_read_investor,
          notification_id: notifi.notification_id
        }
      )
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_KYC_APPROVED) {
      notificationList.push(
        {
          heading: 'Investor KYC form has been approved',
          msgBody: `KYC has been approved by the admin`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read:notifi.is_read,
          notification_id:notifi.notification_id

        })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_KYC_REJECTED) {
      notificationList.push(
        {
          heading: 'Investor KYC form has been rejected',
          msgBody: `KYC has been rejected by the admin`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read:notifi.is_read,
          notification_id:notifi.notification_id

        })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_INTEREST_RECEIVED_FROM_INVESTOR) {
      notificationList.push(
        {
          heading: 'Interest in this investment received!',
          msgBody: `Your request has been received for ${notifi.reference_number} and Bennefin team will contact you to confirm the details`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read: notifi.is_read,
          notify_to : notifi.notify_to,
          notification_id: notifi.notification_id

        })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_PAYMENT_PROCESSED) {
      notificationList.push(
        {
          heading: 'Payment credited to your account!',
          msgBody: `Bennefin transferred $ ${notifi.paid_amount} on ${moment(notifi.paid_date).format("DD MMM YYYY")} to your account via ${notifi.received_via} for the loan, ${notifi.loan_reference_number}`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read: notifi.is_read,
          notify_to : notifi.notify_to,
          notification_id: notifi.notification_id

        })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_LOAN_DELISTED) {
      notificationList.push(
        {
          heading: 'Loan Delisted',
          msgBody: `Your loan ${notifi.loan_reference_number} has been delisted by the admin`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read:notifi.is_read,
          notify_to : notifi.notify_to,
          notification_id:notifi.notification_id

        })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE) {
      notificationList.push(
        {
          heading: 'Loan Technical Closure',
          msgBody: `Your loan ${notifi.reference_number} has been technical closed by the admin`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read:notifi.is_read,
          notify_to : notifi.notify_to,
          notification_id:notifi.notification_id

        })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_RENEW_DOCUMENT) {
      if (notifi.status < new Date()) {
        notificationList.push(
          {
            heading: 'KYC document expiry',
            msgBody: `Renew your ${notifi.reference_number} document which is expired on ${moment(notifi.status).format("DD MMM YYYY")}`,
            notifType: notifi.notification_type,
            date: notifi.created_date_time,
            is_read: notifi.is_read,
            notify_to : notifi.notify_to,
            notification_id: notifi.notification_id

          })
      } else {
        notificationList.push({
          heading: 'KYC document expiry',
          msgBody: `Renew your ${notifi.reference_number} document which will expire on ${moment(notifi.status).format("DD MMM YYYY")}`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read: notifi.is_read,
          notify_to : notifi.notify_to,
          notification_id: notifi.notification_id
        })
      }
    }

  })
  let notifLength = Count.length


  const handleViewDetails = (data) => {
    let extend_url;
    if(parseInt(data.notifType) === NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY){
       extend_url = 'notifications/update_is_read_investor_notification';
    }else{
      extend_url = 'notifications/update_is_read_notification'
    }
    axios
      .post(base_url + extend_url, {
        "notification_id": data.notification_id,
        "investor_id": Cookies.get("investor_id")
      })
      .then((res) => {
        switch (parseInt(data.notifType)) {
          case NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY:

            if (window.location.pathname === '/investmentopportunities') {
              setTimeout(() => {
                window.location.reload()
              }, 800);
            } else {
              navigate("/investmentopportunities")
            }
            break;
          case NOTIFICATION_TYPE_PAYMENT_PROCESSED:

            if (window.location.pathname === '/myinvestments') {
              setTimeout(() => {
                window.location.reload()
              }, 800);
            } else {
              navigate("/myinvestments")
            }
            break;
          case NOTIFICATION_TYPE_INTEREST_RECEIVED_FROM_INVESTOR:
            if (window.location.pathname === '/investornotifications') {
              setTimeout(() => {
                window.location.reload()
              }, 800);
            } else {
              navigate("/investornotifications")
            }
            break;
          case NOTIFICATION_TYPE_RENEW_DOCUMENT:
            if (window.location.pathname === '/investorkycdocuments') {
              setTimeout(() => {
                window.location.reload()
              }, 800);
            } else {
              navigate("/investorkycdocuments")
            }
            break;
          default:
            navigate("/investornotifications");
            break;
        }
      }).catch((e) => {
      })
  }

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <InvestorSideNavBar />
      <main style={{ width: "100%" }}>
        <InvestorNavBarMain count={notifLength} />
        <div className="col-lg-9 m-auto mt-4">
          <h1 className="bus_notific_main">Notifications</h1>


          <div className="">
            <ul className="nav nav-tabs notif_main" id="myTab" role="tablist">
              <li className="nav-item">
                <a className={`nav-link ${activeTab === 'home' ? 'notif_main_active_home' : 'notifinactivestyle_home'}`} onClick={() => handleTabClick('home')} role="tab" aria-selected={activeTab === 'home'}>Read</a>
              </li>
              <li className="nav-item position-relative">
                {Count.length ===0 ? '' : <span className="notifCount">{Count.length}</span>}
                <a className={`nav-link ${activeTab === 'profile' ? 'notif_main_active_profile' : 'notifinactivestyle_profile'}`} onClick={() => handleTabClick('profile')} role="tab" aria-selected={activeTab === 'profile'}>
                  Unread</a>
              </li>

            </ul>
            <div className="tab-content">
              <div className={`tab-pane ${activeTab === 'home' ? 'active' : ''}`} id="home" role="tabpanel">
              <div className="notif_main_div">
                  {loading ? <div>
                    <Skeleton   height={50} />
                    <Skeleton   height={50} />
                  </div> : notificationList.length === 0 ? <div className="text-center text-secondary fs-5 fw-bold mt-5">No notifications to display</div> :
                    notificationList.map(notif => {
                      if ((notif.notify_to === NOTIFICATION_ENTITY_ALLINVESTORS)) {
                        if ((notif?.is_read_investor?.indexOf(Cookies.get("investor_id")) !== -1)) {
                          notif.is_investor_read = 1
                        } else {
                          notif.is_investor_read = 0
                        }
                      }        
                      if(notif.notify_to === NOTIFICATION_ENTITY_INVESTOR)
                        notif.is_investor_read = notif.is_read   
                      if (notif.is_investor_read === 1)
                        return (
                          <div key={notif.ref_no} className="notifpanestyl row me-3">
                            <div className="col-lg-2 notif_time">
                              <b className="notif_date">{moment(notif.date).format("DD MMM YYYY")}</b>
                              <p >{moment(notif.date).format("HH:mm")}</p>
                            </div>
                            <div className="col notif_txt">
                              <h3 className="mb-1">{
                                notif.heading
                              }</h3>
                              <p>{notif.msgBody}.</p>
                            </div>

                          </div>
                        )


                    })}
                </div>


              </div>
              <div className={`tab-pane ${activeTab === 'profile' ? 'active' : ''}`} id="profile" role="tabpanel">

                <div className="notif_main_div">
                  {Count.length === 0 ? <div className="text-center fs-5 mt-5 fw-bold text-secondary">No new notifications</div> :
                    notificationList.map(notif => {
                      if (notif.is_investor_read === 0)
                        return (
                          <div key={notif.ref_no} className="notifpanestyl row me-3">
                            <div className="col-lg-2 notif_time">
                              <b className="notif_date">{moment(notif.date).format("DD MMM YYYY")}</b>
                              <p >{moment(notif.date).format("HH:mm")}</p>
                            </div>

                            <div className="col notif_txt">
                              <h3 className="mb-0">{notif.heading}</h3>
                              <p>{notif.msgBody}.</p>
                              <div className="d-flex gap-3 mt-2">
                                <span className="toast_viewdetails" onClick={() => handleViewDetails(notif)}>View Details</span>
                              </div>
                            </div>

                          </div>
                        )


                    })}
                </div>

              </div>
            </div>
          </div>






        </div>
      </main>
    </div>


  );
}

export default InvestorNotifications;